import { useState, useCallback } from "react";
import { showMessage } from "react-native-flash-message";
import { formatAndRaiseError } from "../helpers/general";
import { requestHelper } from "../helpers/request-helper";

export default useAddCoupon;

async function addCouponApi({ order_id, code }) {
  return requestHelper(
    `
      mutation addCoupon($order_id: Int!, $code: String!) {
        proxyCustomerAddCoupon(orderId: $order_id, code: $code) {
          suceess
        }
      }
    `,
    {
      order_id: order_id,
      code: code,
    }
  )
    .then((data) => {
      return data.proxyCustomerAddCoupon;
    })
    .catch(formatAndRaiseError);
}

async function removeCouponApi({ order_id }) {
  return requestHelper(
    `
      mutation removeCoupon($order_id: Int!) {
        proxyCustomerRemoveCoupon(orderId: $order_id) {
          suceess
        }
      }
    `,
    {
      order_id: order_id,
    }
  )
    .then((data) => {
      return data.proxyCustomerRemoveCoupon;
    })
    .catch(formatAndRaiseError);
}

function convertId(id: string | number): Number {
  if (typeof id === "number") {
    return id;
  } else if (typeof id === "string") {
    let [, id_num] = id.split("_");
    return Number(id_num);
  }
  return id;
}
function useAddCoupon(cart_id: string | undefined) {
  let [loading, setLoading] = useState(false);

  let addCoupon = useCallback(
    async function addCoupon_memo(code) {
      code = code && code.toLowerCase();
      setLoading(true);

      try {
        if (!cart_id) {
          throw new Error("سبد خرید یافت نشد.");
        }
        await addCouponApi({ code, order_id: convertId(cart_id) });
      } catch (e) {
        let general_message = "مشکلی در افزودن کد تخفیف پیش آمده است.";
        let code_error = e.response?.errors && e.response?.errors[0]?.message;
        let falback_error = e.response?.errors[0]?.message;

        let final_error_message = general_message;
        if (code_error) {
          final_error_message = code_error;
        } else if (falback_error) {
          final_error_message = falback_error;
        }

        showMessage({
          message: final_error_message,
          type: "danger",
        });

        throw e;
      } finally {
        setLoading(false);
      }
    },
    [cart_id]
  );

  let removeCoupon = useCallback(
    async function removeCoupon_memo() {
      setLoading(true);

      try {
        await removeCouponApi({ order_id: convertId(cart_id) });

        showMessage({
          message: "کد تخفیف با موفقیت حذف شد.",
          type: "success",
        });
      } catch (e) {
        let general_message = "مشکلی در حذف کد تخفیف پیش آمده است.";

        showMessage({
          message: general_message,
          type: "danger",
        });

        throw new Error(e);
      } finally {
        setLoading(false);
      }
    },
    [cart_id]
  );

  return {
    addCoupon,
    removeCoupon,
    loading,
  };
}
